export default "__VITE_ASSET__Cj9pO3wt__"